export default {
  home: 'Home',
  exhibitionCenters: 'Exhibition Centers',
  hostVenue: 'Host Venue',
  venueArea: 'Venue Area',
  squareMeter: '㎡',
  viewMap: 'View Map',
  countryRegion: 'Country/Region',
  contactPhone: 'Contact Phone',
  officialWebsite: 'Official Website',
  venueDetails: 'Venue Details',
  exhibitionSchedule: 'Exhibition Schedule',
  all: 'All',
  currentYear: 'Current Year',
  nextYear: 'Next Year',
  otherInformation: 'Other Information',
  floorPlan: 'Floor Plan',
  relatedExhibitions: 'Related Exhibitions',
  more: 'More',
  daysUntilExhibition: 'There are still',
  days: 'days',
  exhibitionInProgress: 'In progress...',
  timeUpdating: 'Time is being updated...'
}
